import { useMemo } from 'react';

import { useEffectiveColors } from '@/hooks/use-public-design-settings';
import { deriveContentToneFromColor, resolveColorVariable } from '@/lib/derive-content-tone';
import type { SectionBackgroundContentTone } from '@/lib/section-background';

export function useDerivedContentTone(
  color: string | undefined,
): SectionBackgroundContentTone | null {
  const effectiveColors = useEffectiveColors();

  return useMemo(() => {
    if (!color) return null;

    const resolvedColor = effectiveColors
      ? (resolveColorVariable(color, effectiveColors) ?? color)
      : color;

    return deriveContentToneFromColor(resolvedColor, effectiveColors?.siteText);
  }, [color, effectiveColors]);
}
